var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import styled from 'styled-components';
import gql from 'graphql-tag';
import { Redirect } from 'react-router-dom';
import { Mutation } from 'react-apollo';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as cx from 'classnames';
import { LoggedContext } from 'components/App';
import { MEDIA_QUERIES } from 'shared/style';
import { transformErrorToObject } from 'shared/error';
import { Root } from './styled';
var RootDiv = styled(Root)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    width: 400px;\n    min-height: 150px;\n  }\n\n  > form {\n    > .element {\n      > .label {\n        width: 60px;\n      }\n    }\n\n    > .error {\n      margin-left: 80px;\n    }\n\n    > .button-area {\n      > .login-button {\n        width: 150px;\n      }\n    }\n  }\n"], ["\n  ", " {\n    width: 400px;\n    min-height: 150px;\n  }\n\n  > form {\n    > .element {\n      > .label {\n        width: 60px;\n      }\n    }\n\n    > .error {\n      margin-left: 80px;\n    }\n\n    > .button-area {\n      > .login-button {\n        width: 150px;\n      }\n    }\n  }\n"])), MEDIA_QUERIES.PC_TABLET);
var FIND_PASSWORD = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation FindPassword($email: String!) {\n    findPassword(email: $email)\n  }\n"], ["\n  mutation FindPassword($email: String!) {\n    findPassword(email: $email)\n  }\n"])));
var FindPassword = /** @class */ (function (_super) {
    __extends(FindPassword, _super);
    function FindPassword() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FindPassword.prototype.redirect = function () {
        var history = this.props.history;
        history.push(location.pathname.replace('/find-password', ''));
    };
    FindPassword.prototype.render = function () {
        var _this = this;
        return (React.createElement(LoggedContext.Consumer, null, function (_a) {
            var logged = _a.logged;
            if (logged) {
                return React.createElement(Redirect, { to: { pathname: '/' } });
            }
            return (React.createElement(Mutation, { mutation: FIND_PASSWORD }, function (findPassword) {
                return (React.createElement(RootDiv, null,
                    React.createElement(Formik, { initialValues: { email: '' }, validate: function (values) {
                            var errors = {};
                            if (!values.email) {
                                errors.email = '이메일을 입력해야 합니다.';
                            }
                            else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                                errors.email = '이메일 주소가 잘못 되었습니다.';
                            }
                            return errors;
                        }, onSubmit: function (values, actions) {
                            findPassword({ variables: values }).then(function () {
                                window.alert('이메일로 임시 비밀번호를 전송했습니다.');
                                actions.setSubmitting(false);
                                _this.redirect();
                            }, function (err) {
                                actions.setSubmitting(false);
                                actions.setErrors(transformErrorToObject(err));
                            });
                        } }, function (_a) {
                        var isSubmitting = _a.isSubmitting;
                        return (React.createElement(Form, null,
                            React.createElement("div", { className: "element" },
                                React.createElement("div", { className: "label" },
                                    React.createElement("label", { htmlFor: "email" }, "\uC774\uBA54\uC77C")),
                                React.createElement("div", { className: "input" },
                                    React.createElement(Field, { type: "email", name: "email" }))),
                            React.createElement(ErrorMessage, { name: "email", render: function (msg) { return React.createElement("div", { className: "error" }, msg); } }),
                            React.createElement("div", { className: "button-area" },
                                React.createElement("button", { type: "submit", className: cx('login-button', { disabled: isSubmitting }), disabled: isSubmitting }, "\uBE44\uBC00\uBC88\uD638 \uCC3E\uAE30"))));
                    })));
            }));
        }));
    };
    return FindPassword;
}(React.Component));
export default FindPassword;
var templateObject_1, templateObject_2;
